import { BrowserRouter, Routes, Route } from "react-router-dom";
import { Provider } from "react-redux";
import store from "./store";
import HeaderComponent from "./components/HeaderComponent";
import AdminRoute from "./components/AdminRoute";
import Home from "./layout/Home/Home";
import Login from "./layout/Login/Login";
import NewsCreate from "./layout/NewsCreate/NewsCreate";
import NewsEdit from "./layout/NewsEdit/NewsEdit";
import Register from "./layout/Register/Register";
import "./App.css";

function App() {
  return (
    <Provider store={store}>
      <BrowserRouter>
        <HeaderComponent />
        <Routes>
          <Route path="/" element={<Home />} />
          <Route path="/login" element={<Login />} />
          {/* Register is now protected — only accessible when logged in */}
          <Route
            path="/register"
            element={
              <AdminRoute>
                <Register />
              </AdminRoute>
            }
          />
          <Route
            path="/admin/create"
            element={
              <AdminRoute>
                <NewsCreate />
              </AdminRoute>
            }
          />
          <Route
            path="/admin/edit/:slug"
            element={
              <AdminRoute>
                <NewsEdit />
              </AdminRoute>
            }
          />
        </Routes>
      </BrowserRouter>
    </Provider>
  );
}

export default App;
